<template>
  <div class="container">
    <div class="navi">
        <span class="icon-arrow-left" @click="goto('/household-step2')"></span>
    </div>
    <div class="title">请指定清洁时间</div>
    <datepicker :inline="true" :language="zh" :monday-first="true" v-model="order.data.service_date"  :bootstrap-styling="true" :disabledDates="disabledDates" @selected="changeDate"></datepicker>
    <div class="timerange" v-bind:class="{ visualhidden: !order.temp.isDate}">
      <div class="weui-cells">
        <div class="weui-cell weui-cell_select weui-cell_select-after">
            <div class="weui-cell__hd">
                <label for="" class="weui-label">预约时间</label>
            </div>
            <div class="weui-cell__bd">
                <select class="weui-select" name="select2"  v-model="order.data.service_time">
                    <option value="1">08:00</option>
                    <option value="2">08:30</option>
                    <option value="3">09:00</option>
                    <option value="4">09:30</option>
                    <option value="5">10:00</option>
                    <option value="6">10:30</option>
                    <option value="7">11:00</option>
                    <option value="8">11:30</option>
                    <option value="9">12:00</option>
                    <option value="10">12:30</option>
                    <option value="11">13:00</option>
                    <option value="12">13:30</option>
                    <option value="13">14:00</option>
                    <option value="14">14:30</option>
                    <option value="15">15:00</option>
                    <option value="16">15:30</option>
                    <option value="17">16:00</option>
                    <option value="18">16:30</option>
                    <option value="19">17:00</option>
                    <option value="20">17:30</option>
                    <option value="21">18:00</option>
                    <option value="22">18:30</option>
                    <option value="23">19:00</option>
                    <option value="24">19:30</option>
                    <option value="25">20:00</option>
                    <option value="26">20:30</option>
                </select>
            </div>
        </div>
      </div>
    </div>

    <div class="btn-box">
      <div class="btn" @click="checkSubmit()" :class="{ active: allFilled()}">下一步</div>
    </div>
  </div>
</template>

<script>
import Datepicker from 'vuejs-datepicker';
import {zh} from 'vuejs-datepicker/dist/locale'

export default {
  name: 'household-step5',
  components: {
    Datepicker
  },
  mounted: function () {
    if (localStorage.order) {
      this.order = JSON.parse(localStorage.order);
    }
  },
  methods: {
    changeTime(time) {
      if(time == 'am'){
        this.order.temp.isAM=true;
        this.order.temp.isPM=false;
      }
      if(time == 'pm'){
        this.order.temp.isAM=false;
        this.order.temp.isPM=true;
      }
    },
    changeDate(){
      this.order.temp.isDate=true;
    },
    allFilled(){
        if(this.order.data.service_time && this.order.data.service_date){
            return true;
        }
    },
    checkSubmit(){
        if(this.allFilled()){
            this.orderUpdateAll('/household-step3');
        }
        else{
            alert('请选择服务日期和时间')
        }
    }
  },
  data () {
    return {
      'order':{
        data:{
          date:'',
        },
        temp:{
          isAM:'',
          isPM:'',
          isDate:'',
        }
      },
      'address':{},
      zh: zh,
      disabledDates: {
        to: new Date(),
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>

.container /deep/{
  .weui-cells{
    border:2px solid #fe9567;
    border-radius:5px;
    margin:10px 40px;
    &:before, &:after{
      border:0;
    }
  }
  .weui-cell__hd{
    margin-right:10px;
  }
}

.weui-cells__title{
  margin-top:20px;
}

.timerange{
  text-align:center;
  margin-top:20px;
}

.date{
  color:#fe9567;
  display:inline-block;
  font-weight:600;
  font-size:1.1em;
  margin:0 10pt;
}

.option-btn{
  border:2px solid #fe9567;
  border-radius:4px;
  width:68px;
  height:34px;
  line-height:34px;
  color:#ff7444;
  display:inline-block;
  margin:0 4px;
	text-align:center;
}

.option-btn.active{
  border:2px solid #fe9567;
  border-radius:4px;
  width:68px;
  height:34px;
  line-height:34px;
  background-color:#fe9567;
  color:#fff;
  display:inline-block;
  margin:0 4px;
	-webkit-box-shadow: 0 10px 16px -10px rgba(237,121,75,0.8);
	-moz-box-shadow: 0 10px 16px -10px rgba(237,121,75,0.8);
  box-shadow: 0 10px 16px -10px rgba(237,121,75,0.8);
}

.container /deep/ .cell.selected{
  background:#EF885E;
  border-radius:30px;
  color:#fff;
}
.container /deep/ .vdp-datepicker__calendar .cell.selected:hover{
  background:#EF885E;
}

.container /deep/ .vdp-datepicker__calendar .cell:not(.blank):not(.disabled).day:hover, .vdp-datepicker__calendar .cell:not(.blank):not(.disabled).month:hover, .vdp-datepicker__calendar .cell:not(.blank):not(.disabled).year:hover{
  border:0;
}

.container /deep/ .vdp-datepicker__calendar{
    border:0;
    padding:0 20pt;
    width:100%;
}

.container /deep/ .cell.selected:hover{
  border:solid 1px #EF885E;
}

.container /deep/ .cell:hover{
  border:solid 1px #EF885E;
}

</style>



// WEBPACK FOOTER //
// src/pages/household/step3.vue